import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useApp } from '../../contexts/AppContext';
import { useAuth } from '../../contexts/AuthContext';
import { TICKET_STATUSES } from '../../config/constants';

const { FiSearch, FiRefreshCw, FiUser, FiLifeBuoy } = FiIcons;

const TopBar = ({ onRefresh }) => {
  const {
    apps,
    selectedApp,
    setSelectedApp,
    statusFilters,
    setStatusFilters,
    searchQuery,
    setSearchQuery,
  } = useApp();
  const { user } = useAuth();

  const handleStatusToggle = (status) => {
    setStatusFilters((current) => current.includes(status) ? current.filter((item) => item !== status) : [...current, status]);
  };

  return (
    <header className="topbar-shell bg-surface border-b border-border px-3 sm:px-4 lg:px-6 py-3 shrink-0">
      <div className="topbar-row">
        <div className="mobile-topbar-brand">
          <div className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center"><SafeIcon icon={FiLifeBuoy} className="w-5 h-5 text-surface" /></div>
          <div className="min-w-0"><p className="text-[11px] font-semibold uppercase tracking-wide text-muted">BPA Solutions</p><p className="text-sm font-bold text-text truncate">Support Hub</p></div>
        </div>

        <div className="topbar-search relative">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted w-5 h-5" />
          <input type="text" placeholder="Search tickets..." value={searchQuery} onChange={(event) => setSearchQuery(event.target.value)} className="control pl-10" />
        </div>

        <select value={selectedApp} onChange={(event) => setSelectedApp(event.target.value)} className="topbar-app-select control font-medium">
          <option value="All Apps">All Apps</option>
          {apps.map((app) => <option key={app.id} value={app.appName}>{app.appName}</option>)}
        </select>

        <div className="topbar-actions">
          <motion.button onClick={onRefresh} className="topbar-icon-button" whileTap={{ scale: 0.94 }} aria-label="Refresh"><SafeIcon icon={FiRefreshCw} className="w-5 h-5" /></motion.button>
          <div className="topbar-user-chip">
            <SafeIcon icon={FiUser} className="w-5 h-5 text-muted" />
            <span className="text-sm font-medium text-text truncate max-w-40">{user?.name || user?.email || 'Agent'}</span>
          </div>
        </div>
      </div>

      <div className="topbar-status-strip" aria-label="Ticket status filters">
        {TICKET_STATUSES.map((status) => (
          <motion.button key={status} onClick={() => handleStatusToggle(status)} className={`topbar-status-chip ${statusFilters.includes(status) ? 'topbar-status-chip-active' : ''}`} whileTap={{ scale: 0.97 }}>
            {status}
          </motion.button>
        ))}
      </div>
    </header>
  );
};

export default TopBar;